(() => {
  const key = 'mc-review-summary';
  function init() {
    document.querySelectorAll('[data-mc-top-reviews]').forEach(link => {
      if (link.dataset.ready) return;
      link.dataset.ready = 'true';
      const scoreLabel = link.querySelector('[data-mc-review-score]');
      const countLabel = link.querySelector('[data-mc-review-count]');
      const locale = document.documentElement.lang || 'nl';
      const paint = (score, count) => {
        if (!(score > 0 && score <= 5 && count > 0)) return;
        scoreLabel.textContent = new Intl.NumberFormat(locale, {minimumFractionDigits:1, maximumFractionDigits:1}).format(score);
        countLabel.textContent = new Intl.NumberFormat(locale).format(count);
      };
      paint(Number(link.dataset.score.replace(',', '.')), Number(link.dataset.count));
      try {
        const cached = JSON.parse(sessionStorage.getItem(key));
        if (cached && Date.now() - cached.time < 86400000) paint(cached.score, cached.count);
      } catch (_) {}
      const target = document.querySelector('#mascolori-reviews');
      if (!target) return;
      link.href = '#mascolori-reviews';
      const widget = target.querySelector('.reputon-google-reviews-widget');
      if (!widget) return;
      const update = () => {
        const score = parseFloat(widget.querySelector('.reputon-count-number')?.textContent.replace(',', '.'));
        const count = parseInt(widget.querySelector('.reputon-reviews-count')?.textContent.replace(/\D/g, ''), 10);
        if (!(score > 0 && score <= 5 && count > 0)) return;
        paint(score, count);
        try { sessionStorage.setItem(key, JSON.stringify({score, count, time:Date.now()})); } catch (_) {}
      };
      update();
      const observer = new MutationObserver(update);
      observer.observe(widget, {childList:true, subtree:true, characterData:true});
      setTimeout(() => observer.disconnect(), 30000);
    });
  }
  init();
  document.addEventListener('shopify:section:load', init);
})();
